// A persona's per-reply output-token limit (SA-1241). Twin of
// backend/app/services/reply_budget.py.
export const DEFAULT_REPLY_BUDGET = 8192
export const MAX_REPLY_BUDGET = 16384
export const MIN_REPLY_BUDGET_SLIDER = 1024
export const REPLY_BUDGET_STEP = 1024
